import { Component, OnInit } from '@angular/core';
import { ProductsService } from '../../service/main/products.service';
import { isNullOrUndefined } from 'util';
import { ToastrService } from '../../service/common/toastr.service';
import { PaginationService } from '../../service';
import {
    ParkingProduct,
    Product
} from '../../entity';
import { ISort } from '../../interfaces';

@Component({
    selector: 'app-products',
    templateUrl: './products.component.html'
})
export class ProductsComponent implements OnInit {
    parkingProducts: Array<ParkingProduct> = new Array<ParkingProduct>();
    selectedParkingProduct: ParkingProduct = new ParkingProduct();
    filteredList: Array<ParkingProduct>;

    //#region component state properties
    loadingState = false;
    noRecordsState = false;
    //#endregion

    //#region search & sort properties
    tags = new Array<string>();
    searchWord = '';
    sortOptions: ISort[];
    selectedSortOption: ISort;
    reverse = false;
    //#endregion

    //#region pagination properties
    pagedItems: Array<Product>;
    pager: any = {};
    //#endregion


    constructor(
        private productsService: ProductsService,
        private toastrService: ToastrService,
        private paginationService: PaginationService
    ) { }

    ngOnInit() {
        this.refresh();
        this.sortOptions = sortOptions;
        this.selectedSortOption = sortOptions[0];
    }

    refresh() {
        this.loadingState = true;
        this.productsService.getProducts().subscribe(data => {
            const parkingProducts = new Array<ParkingProduct>();
            data.forEach(item => {
                const parkingProduct = new ParkingProduct();
                parkingProduct.fromObject(item);

                parkingProduct.Product = new Product();
                parkingProduct.Product.fromObject(item.product);
                parkingProduct.Code = parkingProduct.Product.Code;

                parkingProducts.push(parkingProduct);
            });

            this.parkingProducts = parkingProducts;
            this.filteredList = this.paginationService.sortArray(parkingProducts, this.selectedSortOption.objKey, this.reverse);
            this.loadingState = false;
            this.setPage(1);
            if (this.parkingProducts.length > 0) {
                this.noRecordsState = false;
            } else {
                this.noRecordsState = true;
            }
        }, (err) => {
            this.loadingState = false;
            this.noRecordsState = true;
        });
    }

    getProductDescription(id: string) {
        this.parkingProducts.forEach(product => {
            if (product.ParkingProductID === id) {
                this.selectedParkingProduct = product;
            }
        });
    }

    removeProduct(id: string) {
        if (!isNullOrUndefined(id)) {
            this.productsService.deleteProduct(id).subscribe(res => {
                const findIndex = this.parkingProducts.findIndex(item => item.ParkingProductID === id);
                this.parkingProducts.splice(findIndex, 1);
                this.toastrService.success('Product successfully removed.');
            }, err => {
                this.toastrService.error('An error has occurred while removing the product.');
            });
        }
    }

    //#region pagination, search, sort
    updateFilterTags(tags: Array<string>) {
        this.tags = tags;
        this.refreshFilteredList();
    }

    search(word?: string): void {
        this.searchWord = word;
        this.refreshFilteredList();
    }

    changeSortOption(sortOption: ISort): void {
        this.selectedSortOption = sortOption;
        this.refreshFilteredList();
    }

    toggleReverse(reverse: boolean): void {
        this.reverse = reverse;
        this.refreshFilteredList();
    }

    refreshFilteredList(): void {
        this.filteredList = this.parkingProducts;
        this.filteredList = this.paginationService.filterArray(this.filteredList, 'ParkingTitle', this.tags);
        this.filteredList = this.paginationService.filterArray(this.filteredList, 'Code', [this.searchWord]);
        this.filteredList = this.paginationService.sortArray(this.filteredList, this.selectedSortOption.objKey, this.reverse);
        this.setPage(1);
    }

    setPage(page: number): void {
        this.pager = this.paginationService.getPager(this.filteredList.length, page, 6);
        this.pagedItems = this.filteredList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
    //#endregion
}

const sortOptions: ISort[] = [
    { displayName: 'Cod produs', objKey: 'Code' },
    { displayName: 'Data adaugare', objKey: 'Date' },
];
